import React from "react";
import { BadgeCheck } from "lucide-react";

/**
 * Бейдж "Личность подтверждена" — документальная верификация исполнителя
 * (паспорт + селфи, проверено администратором). Отдельно от "Проверенный исполнитель"
 * (репутационный бейдж) — этот означает подтверждённую личность.
 *
 * Props:
 *  - size: "xs" | "sm" | "md" — размер
 *  - showLabel: bool — показывать текст рядом с иконкой (по умолчанию true для md, false для xs/sm)
 */
export const IdentityVerifiedBadge = ({ size = "sm", showLabel, title = "Личность подтверждена", className = "" }) => {
  const sizePresets = {
    xs: { wrap: "px-1.5 py-0.5 text-[10px] gap-0.5", icon: 10 },
    sm: { wrap: "px-2 py-0.5 text-[11px] gap-1", icon: 12 },
    md: { wrap: "px-2.5 py-1 text-xs gap-1.5", icon: 14 },
  };
  const cfg = sizePresets[size] || sizePresets.sm;
  const labelVisible = showLabel ?? (size === "md" || size === "sm");

  return (
    <span
      title={title}
      data-testid="identity-verified-badge"
      className={`reversia-identity-badge inline-flex items-center font-semibold rounded-full leading-none ${cfg.wrap} ${className}`}
    >
      <BadgeCheck size={cfg.icon} className="reversia-identity-badge__icon" />
      {labelVisible && <span className="reversia-identity-badge__text">Личность подтверждена</span>}
    </span>
  );
};

export default IdentityVerifiedBadge;
